var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoEventsLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2998 68.1101C61.3355 68.0673 61.3657 68.0203 61.3898 67.9701C61.3657 68.0203 61.3355 68.0673 61.2998 68.1101ZM61.5198 67.6501C61.5306 67.5437 61.5306 67.4365 61.5198 67.3301V60.0901V67.3301C61.5306 67.4365 61.5306 67.5437 61.5198 67.6501ZM61.4298 67.9101C61.4591 67.8457 61.4825 67.7787 61.4998 67.7101C61.4825 67.7787 61.4591 67.8457 61.4298 67.9101Z",
    fill: "url(#paint0_linear_95_37905)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1299 52.1099L60.6299 78.3899L64.8799 75.8799L19.3999 49.6299L15.1299 52.1099Z",
    fill: "url(#paint1_linear_95_37905)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6598 52.8499L30.4098 57.07C30.319 57.2133 30.1956 57.3332 30.0498 57.4199L32.8798 55.77C33.0256 55.6832 33.149 55.5633 33.2398 55.4199L35.4998 51.2L32.6598 52.8499Z",
    fill: "url(#paint2_linear_95_37905)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4499 26.5801L20.6299 1.86012C20.4869 1.75668 20.319 1.69294 20.1434 1.67537C19.9677 1.65781 19.7906 1.68705 19.6299 1.76012L15.6299 4.06012C15.7906 3.98705 15.9677 3.95781 16.1434 3.97537C16.319 3.99294 16.4869 4.05668 16.6299 4.16012L59.4799 28.8801C59.8929 29.1525 60.2364 29.5177 60.483 29.9466C60.7296 30.3755 60.8723 30.8562 60.8999 31.3501L60.7999 67.4301C60.8161 67.6053 60.7859 67.7818 60.7121 67.9415C60.6384 68.1013 60.5238 68.2388 60.3799 68.3401L64.3799 66.0401C64.5238 65.9388 64.6384 65.8013 64.7121 65.6415C64.7859 65.4818 64.8161 65.3053 64.7999 65.1301L64.8799 29.0001C64.8459 28.5134 64.699 28.0412 64.4508 27.6212C64.2026 27.2011 63.8599 26.8447 63.4499 26.5801Z",
    fill: "url(#paint3_linear_95_37905)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4804 28.8801C59.8934 29.1524 60.2369 29.5176 60.4835 29.9465C60.7301 30.3754 60.8728 30.8561 60.9004 31.3501L60.8004 67.4301C60.8004 68.3301 60.1504 68.6901 59.3804 68.2401L32.6804 52.8401L30.4204 57.0601C30.3577 57.1727 30.2716 57.2705 30.1679 57.347C30.0642 57.4235 29.9453 57.4768 29.8192 57.5034C29.6931 57.5299 29.5628 57.5291 29.437 57.5009C29.3113 57.4727 29.1931 57.4179 29.0904 57.3401C28.5277 56.9768 28.0992 56.4395 27.8704 55.8101L25.5404 48.7201L16.5404 43.5201C16.1257 43.251 15.7802 42.8881 15.5318 42.4607C15.2833 42.0334 15.139 41.5536 15.1104 41.0601L15.2304 5.00007C15.2304 4.10007 15.8704 3.73007 16.6604 4.19007L59.4804 28.8801Z",
    fill: "url(#paint4_linear_95_37905)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4804 28.8801C59.8934 29.1524 60.2369 29.5176 60.4835 29.9465C60.7301 30.3754 60.8728 30.8561 60.9004 31.3501L60.8004 67.4301C60.8004 68.3301 60.1504 68.6901 59.3804 68.2401L32.6804 52.8401L30.4204 57.0601C30.3577 57.1727 30.2716 57.2705 30.1679 57.347C30.0642 57.4235 29.9453 57.4768 29.8192 57.5034C29.6931 57.5299 29.5628 57.5291 29.437 57.5009C29.3113 57.4727 29.1931 57.4179 29.0904 57.3401C28.5277 56.9768 28.0992 56.4395 27.8704 55.8101L25.5404 48.7201L16.5404 43.5201C16.1257 43.251 15.7802 42.8881 15.5318 42.4607C15.2833 42.0334 15.139 41.5536 15.1104 41.0601L15.2304 5.00007C15.2304 4.10007 15.8704 3.73007 16.6604 4.19007L59.4804 28.8801Z",
    fill: "url(#paint5_linear_95_37905)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4804 28.8801C59.8934 29.1524 60.2369 29.5176 60.4835 29.9465C60.7301 30.3754 60.8728 30.8561 60.9004 31.3501L60.8004 67.4301C60.8004 68.3301 60.1504 68.6901 59.3804 68.2401L32.6804 52.8401L30.4204 57.0601C30.3577 57.1727 30.2716 57.2705 30.1679 57.347C30.0642 57.4235 29.9453 57.4768 29.8192 57.5034C29.6931 57.5299 29.5628 57.5291 29.437 57.5009C29.3113 57.4727 29.1931 57.4179 29.0904 57.3401C28.5277 56.9768 28.0992 56.4395 27.8704 55.8101L25.5404 48.7201L16.5404 43.5201C16.1257 43.251 15.7802 42.8881 15.5318 42.4607C15.2833 42.0334 15.139 41.5536 15.1104 41.0601L15.2304 5.00007C15.2304 4.10007 15.8704 3.73007 16.6604 4.19007L59.4804 28.8801Z",
    fill: "url(#paint6_linear_95_37905)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9903 37.07L57.9803 40.97L18.0303 17.9L18.0403 14L57.9903 37.07Z",
    fill: "url(#paint7_linear_95_37905)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9903 45.1101L57.9803 49.0201L18.0303 25.9501L18.0403 22.05L57.9903 45.1101Z",
    fill: "url(#paint8_linear_95_37905)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6203 45.04L44.6103 48.9399L18.0303 33.5999L18.0403 29.7L44.6203 45.04Z",
    fill: "url(#paint9_linear_95_37905)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7596 30.5501C60.8489 30.8075 60.8962 31.0777 60.8997 31.3501V35.3001L61.3097 35.1701V31.3501C61.2836 30.7839 61.1219 30.2322 60.8382 29.7415C60.5546 29.2508 60.1573 28.8353 59.6796 28.5301L16.8596 3.80011C16.7208 3.72011 16.5731 3.65636 16.4196 3.61011L15.6396 4.06011C15.7072 4.0325 15.7777 4.01238 15.8496 4.00011H15.9996H16.0996H16.3296L16.5996 4.12011L38.0696 16.5201L59.4796 28.8801C60.0829 29.276 60.5341 29.8647 60.7596 30.5501Z",
    fill: "url(#paint10_linear_95_37905)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_37905",
    x1: 61.4398,
    y1: 66.9901,
    x2: 61.4398,
    y2: 60.0101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_95_37905",
    x1: 28.4899,
    y1: 44.0599,
    x2: 53.0399,
    y2: 86.5799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_95_37905",
    x1: 30.0498,
    y1: 54.31,
    x2: 35.4998,
    y2: 54.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_95_37905",
    x1: 28.6099,
    y1: -3.96988,
    x2: 70.6899,
    y2: 68.9201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_95_37905",
    x1: 1755.59,
    y1: 3833.77,
    x2: 1755.59,
    y2: 214.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_95_37905",
    x1: 21.5204,
    y1: 36.2001,
    x2: 61.3904,
    y2: 36.2001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_95_37905",
    x1: 1755.59,
    y1: 3833.77,
    x2: 1755.59,
    y2: 214.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_95_37905",
    x1: 17.6803,
    y1: 15.75,
    x2: 55.3703,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_95_37905",
    x1: 587.061,
    y1: 610.266,
    x2: 1746.42,
    y2: 1601.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_95_37905",
    x1: 309.457,
    y1: 559.954,
    x2: 1126.08,
    y2: 1211.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_95_37905",
    x1: 15.1396,
    y1: 5.72011,
    x2: 63.0596,
    y2: 33.5201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FEFEFE",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FCFCFC",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F8F8F8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F2F2F2",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EAEAEA",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#E1E1E1",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D7D7D7",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D0D0D0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEventsLarge);
export default __webpack_public_path__ + "static/media/no_events_large.b63954471f846156bd54aa7eda866689.svg";
export { ForwardRef as ReactComponent };